import { forwardRef, Ref } from 'react';
import { useController, type UseControllerProps } from 'react-hook-form';
import { SelectMenusProps } from 'src/components/SelectMenus/Types';
import SelectMenus from '../../SelectMenus/SelectMenus';
import { Prettify } from 'src/types';
import { Items } from 'src/components/SelectMenus/Types';

type SelectMenuControlledProps<T extends Items = Items> = Prettify<
    Omit<SelectMenusProps<T>, 'onSelect'> & UseControllerProps
>;

export default forwardRef(function SelectMenuControlled<
    T extends Items = Items,
>(props: SelectMenuControlledProps<T>, ref: Ref<HTMLDivElement>) {
    const { field, fieldState } = useController(props);
    return (
        <SelectMenus
            {...props}
            error={fieldState.error?.message}
            onSelect={field.onChange}
            {...field}
            ref={ref}
        />
    );
});
